module.exports = __webpack_public_path__ + "img/tv.52406966.svg";